import React, { Component, PureComponent } from "react";

export default class TextNarrativeExport extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="textnarrativeexport"
        style={{
          display: this.props.isHidden ? "block" : "none",
        }}
      >
        <h4 className="textnarrativeexportText">Text Narrative: </h4>
        <p>{this.props.chartData.textNarrative}</p>
      </div>
    );
  }
}
